import Player from '@vimeo/player';

/**
 * Creates a script tag for youtube api
 *
 * @returns void
 */
function getYoutubeApi() {
  const tag = <HTMLScriptElement>document.createElement('script');
  tag.src = 'https://www.youtube.com/iframe_api';
  const firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

getYoutubeApi();

/**
 * Starts the video when the player is ready
 *
 * @param  {Event} event
 * @returns void
 */
function onPlayerReady(event: Event) {
  // @ts-ignore - TS doesn't know about event.target
  event.target.playVideo();
}

/**
 * Create the youytube player based on the video id
 *
 * @returns {YTPlayer}
 */
function initialzieVideoPlayer(targetId: string) {
  // @ts-ignore - TS doesn't know about YT
  const player = new YT.Player('hhit-yt-lightbox-wrapper', {
    height: '390',
    width: '640',
    videoId: targetId,
    playerVars: {
      playsinline: 1,
    },
    events: {
      onReady: onPlayerReady,
    },
  });

  return player;
}

function initialzieVimeoPlayer() {
  const options = {
    id: 'https://vimeo.com/710246799/e1722bfb7b',
    width: 640,
    loop: true,
  };

  const player = new Player('hhit-yt-lightbox-wrapper', options);

  player.play();
}

function toggleLightbox() {
  const lightbox = document.querySelector('.hhit-lightbox');
  lightbox.classList.toggle('hhit-lightbox--active');

  return lightbox;
}

function resetPlayer() {
  toggleLightbox();
  const player = document.querySelector('.hhit-lightbox__player');
  player.innerHTML = '<div id="hhit-yt-lightbox-wrapper"></div>';
}

// Get youtube script
// getYoutubeApi();

const ytPlayButtons = document.querySelectorAll(
  '.yt-embed-block__button',
) as NodeListOf<HTMLButtonElement>;

ytPlayButtons.forEach((button) => {
  button.addEventListener('click', (event: Event) => {
    // Get video ID
    const { id } = button.dataset;

    // Toggle lightbox
    toggleLightbox();

    console.log(id);

    // Initialize video player`
    const player = initialzieVideoPlayer(id);
  });
});

document.getElementById('closePlayer').addEventListener('click', () => {
  resetPlayer();
});

document.addEventListener('keydown', (event: KeyboardEvent) => {
  if (event.keyCode === 27) resetPlayer();
});
